<script setup lang="ts">
import { computed } from 'vue';

import { getBreakpoint } from '@sg-core/resources/assets/js/utils';
import type { PhxsgSliderProps as PhxsgCoreSliderProps } from '@sg-core/src/View/Components/Organisms/Slider';
import { mergeOptions } from '@sg-core/src/View/Components/Organisms/Slider/phxsg-slider.vue';

import { PhxsgContainer } from '../../Atoms/Container';
import { PhxsgSlider } from '../../Organisms/Slider';
import { PhxsgSliderProps } from '../Slider/phxsg-slider.vue';

const props = withDefaults(defineProps<PhxsgCoreSliderProps>(), {
  navigation: true,
  pagination: () => ({ xs: true, md: false }),
});

const tabletBreakpoint = getBreakpoint('md');
const desktopBreakpoint = getBreakpoint('lg');

const mergedOptions = computed(() => {
  const defaultOptions: PhxsgCoreSliderProps = {
    slidesPerView: 'auto',
    spaceBetween: 8,
    centerInsufficientSlides: true,
    breakpoints: {
      [tabletBreakpoint]: {
        spaceBetween: 8,
      },
      [desktopBreakpoint]: {
        spaceBetween: 12,
      },
    },
  };

  return mergeOptions(defaultOptions, props) as PhxsgSliderProps;
});
</script>

<template>
  <PhxsgContainer class="phxsg-product-card-slider-container">
    <PhxsgSlider class="phxsg-product-card-slider" v-bind="mergedOptions" controls-layout="outer">
      <slot />
    </PhxsgSlider>
  </PhxsgContainer>
</template>

<style src="./product-card-slider.css" />
